<template>
  <div data-test-id="page-header-info">
    <tippy
      tag="button"
      content-tag="div"
      content-class="content-wrapper"
      :interactive="true"
      placement="right-start"
      max-width="250px"
    >
      <template #default>
        <cb-icon-information
          :width="18"
          color="currentColor"
          class="tw-text-primary-grey-200"
        />
      </template>
      <template #content>
        <div>{{ text }}</div>
        <a
          v-if="docsLink"
          :href="docsLink"
          target="_blank"
          class="tw-inline-block tw-underline tw-text-branding-blue-500"
        >
          <span class="tw-flex tw-gap-1 tw-items-center">
            {{ $t("text-block-learn-more") }}
            <cb-icon-external-link :width="16" />
          </span>
        </a>
      </template>
    </tippy>
  </div>
</template>

<script setup lang="ts">
type Props = {
  text: string;
  docsLink: string;
};

defineProps<Props>();
</script>
